/** The business day, in the viewer's own timezone.
 *  `new Date().toISOString()` is UTC, so after 8pm Eastern it returns tomorrow — which is why the
 *  dashboard showed the wrong day every evening. Always go through these helpers.
 */
export const todayIso = (d = new Date()) => {
  const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
};

export const isoToDate = (iso) => new Date(`${iso}T12:00:00`);

export const longDate = (d = new Date()) =>
  d.toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
